<template>
<div class="stock-data" v-if="MICEX.value">
    <div class="stock-data__content-header">
        <span v-html="text.shares"></span>
    </div>
    <div class="stock-data__index">MCX: RASP</div>
    <div class="stock-data__container">
        <div class="stock-data__price" v-html="MICEX.value"></div>
        <div class="stock-data__info">
            <div class="stock-data__difference">
                <span class="stock-data__difference-value">
                    <span v-html="MICEX.change"></span> (<span v-html="MICEX.changedPercent"></span>%)
                </span>

                <z-icon
                    name="mini_arrow"
                    :dir="MICEX.percentIsNegative ? 'down' : 'up'"
                    width="16"
                    height="16"
                    :color="MICEX.percentIsNegative ? '#bb2532' : '#2D6356'"
                >
                </z-icon>
            </div>
            <span class="stock-data__date" v-html="MICEX.date"></span>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable camelcase */
import moment from 'moment'
import { localize } from '@/utils/i18n'
import { getStocks } from '@/api/stocks'

export default {
    name: 'stock-data',
    data () {
        return {
            text: {
                shares: localize({
                    ru: 'Курс акций ММВБ-РТС',
                    en: 'Share price MOEX'
                })
            },
            MICEX: {
                value: '',
                change: '',
                tooltip: '',
                changedPercent: ''
            }
        }
    },
    methods: {
        getFormattedString (str, dec) {
            let out = parseFloat(str).toFixed(dec)
            if (this.$root.lang === 'ru') {
                out = out.replace(/\./g, ',')
                out = out.replace(/\B(?=(\d{3})+(?!\d))/g, '&nbsp;')
            } else {
                out = out.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            return out
        },
        async loadMoex () {
            const lang = this.$root.lang
            const payload = lang === 'ru' ? 'rus' : 'eng'
            let stocksResponse = await getStocks(payload)

            if (stocksResponse.items?.length) {
                moment.locale(lang)

                const [{last_price, last_price_prev, date, time}] = stocksResponse.items
                const tooltip = lang === 'ru'
                    ? `Данные предоставляются с задержкой как минимум на 15 минут по состоянию на ${moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm')} (GMT+03:00)`
                    : `Market data delayed by 15 minutes as ${moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm')} (GMT+03:00)`

                const changedPercent = this.getFormattedString((last_price - last_price_prev) / last_price_prev * 100, 2)

                this.MICEX = {
                    ...this.MICEX,
                    value: this.getFormattedString(last_price, 2),
                    change: this.getFormattedString(last_price - last_price_prev, 2),
                    percentIsNegative: changedPercent[0] === '-',
                    date: moment(`${date} | ${time}`, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm'),
                    changedPercent,
                    tooltip
                }
            } else {
                console.error('Error: MICEX request')
            }
        }
    },
    mounted () {
        this.loadMoex()
    }

}
</script>

<style lang="scss">
.stock-data {
    &__content-header {
        font-weight: 500;
        font-size: 24px;
        line-height: 140%;
        color: $token-colors-black-80;
        @include margin-level(bottom, XS);
    }

    &__index {
        font-size: 18px;
        line-height: 120%;
        color: $token-colors-black;
        text-transform: uppercase;
        @include margin-level(bottom, 3XS);
    }

    &__price {
        font-weight: 600;
        font-size: 44px;
        line-height: 120%;
        color: #EF7812;
        @include margin-level(right, XS);
    }

    &__difference {
        font-size: 24px;
        line-height: 140%;
        color: $token-colors-black-60;
        display: flex;
        align-items: center;
        @include margin-level(right, XS);
    }

    &__difference-value {
        @include margin-level(right, 3XS);
    }

    &__date {
        font-size: 18px;
        line-height: 140%;
        color: $token-colors-black-60;
    }

    &__info {
        display: flex;
        align-items: center;

        @include breakpoint (mobile) {
            flex-direction: column;
            align-items: flex-start;
        }
    }

    &__container {
        display: flex;
        align-items: flex-end;

        @include breakpoint (v-tablet) {
            align-items: flex-start;
            flex-direction: column;
        }
    }
}
</style>
